/* ─── GEGIX Product Customizer — Dropdown Selectors ─── */
/* eslint-disable */

(function () {
  "use strict";

  const SAAS_BASE = "https://www.gegix.com/apps/dashboard";
  const productKind = window.GEGIX_PRODUCT_KIND || "";
  const supportsEmbroidery = productKind !== "pant";

  const productProfileRule = {
    top: { category: "Scrubs", subCategory: "", label: "Body Profile" },
    pant: { category: "Scrubs", subCategory: "", label: "Body Profile" },
    set: { category: "Scrubs", subCategory: "", label: "Body Profile" },
    lab_coat: { category: "Lab Coat", subCategory: "", label: "Lab Coat Profile" },
  }[productKind] || { category: "", subCategory: "", label: "Body Profile" };

  // ─── State ────────────────────────────────────────────

  let customerEmail = window.GEGIX_CUSTOMER_EMAIL || null;
  let bodyProfiles = [];
  let embroideryProfiles = [];
  let selectedBodyProfile = null;
  let selectedEmbroideryProfile = null;
  let profilesLoaded = false;
  let embroideryWanted = false;

  // ─── DOM refs ─────────────────────────────────────────

  let container, bodyTrigger, bodyDropdown;
  let embToggleYes, embToggleNo, embBody, embDropdown;

  // ─── Icons (inline SVG) ──────────────────────────────

  const ICONS = {
    bolt: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`,
    body: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7z"/><path d="M5 21c0-3.87 3.13-7 7-7s7 3.13 7 7"/></svg>`,
    embroidery: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>`,
    chevron: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>`,
    check: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`,
    lock: `<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`,
  };

  // ─── Build HTML ──────────────────────────────────────

  function buildContainer() {
    const el = document.createElement("div");
    el.id = "gegix-customizer";
    el.innerHTML = `
      <div class="gegix-card-header">
        ${ICONS.bolt}
        <span>Customize Your Fit</span>
      </div>
      <p class="gegix-fit-intro">We use your Body Profile to make this garment for your body, not a standard size chart.</p>
      <div class="gegix-fit-steps" aria-label="Custom fit steps">
        <span><strong>1</strong> Select profile</span>
        <span><strong>2</strong> Add to cart</span>
        <span><strong>3</strong> We tailor it</span>
      </div>
      ${buildSection("body", productProfileRule.label, "bodyProfiles")}
      ${supportsEmbroidery ? buildSection("embroidery", "Embroidery", "embroideryProfiles") : ""}
    `;
    return el;
  }

  function buildSection(type, label, dataKey) {
    const loggedIn = !!customerEmail;
    const isEmb = type === "embroidery";

    if (isEmb) {
      // Embroidery: toggle + collapsible body
      return `
        <div class="gegix-profile-section" id="gegix-section-${type}">
          <div class="gegix-profile-header">
            ${ICONS[type]}
            ${label}
          </div>
          <div class="gegix-toggle-group">
            <button class="gegix-toggle-btn ${loggedIn ? "" : "gegix-disabled"}" id="gegix-toggle-emb-no" type="button" data-toggle="no">
              ${!loggedIn ? `${ICONS.lock} ` : ""}No, thanks
            </button>
            <button class="gegix-toggle-btn ${loggedIn ? "" : "gegix-disabled"}" id="gegix-toggle-emb-yes" type="button" data-toggle="yes">
              ${!loggedIn ? `${ICONS.lock} ` : ""}Yes
            </button>
          </div>
          <div class="gegix-toggle-body" id="gegix-embroidery-body" style="display:none">
            <button class="gegix-selector-trigger" 
                    id="gegix-trigger-${type}" 
                    type="button"
                    aria-haspopup="listbox"
                    aria-expanded="false">
              <span class="gegix-trigger-label gegix-trigger-placeholder">
                Select Embroidery...
              </span>
              <span class="gegix-trigger-arrow">${ICONS.chevron}</span>
            </button>
            <div class="gegix-selector-dropdown" id="gegix-dropdown-${type}" role="listbox">
              <div class="gegix-selector-loading">
                <div class="gegix-selector-spinner"></div>
                <span>Loading your profiles...</span>
              </div>
            </div>
          </div>
          <div class="gegix-error" id="gegix-error-${type}" style="display:none"></div>
        </div>`;
    }

    // Body profile: standard section with dropdown
    return `
      <div class="gegix-profile-section" id="gegix-section-${type}">
        <div class="gegix-profile-header">
          ${ICONS[type]}
          ${label}
        </div>
        <button class="gegix-selector-trigger ${loggedIn ? "" : "gegix-disabled"}" 
                id="gegix-trigger-${type}" 
                type="button"
                ${loggedIn ? 'aria-haspopup="listbox"' : ""}
                ${loggedIn ? 'aria-expanded="false"' : ""}>
          <span class="gegix-trigger-label ${loggedIn ? "gegix-trigger-placeholder" : ""}">
            ${loggedIn ? `Select or create your ${label}` : `${ICONS.lock} Log in to select or create your ${label}`}
          </span>
          ${loggedIn ? `<span class="gegix-trigger-arrow">${ICONS.chevron}</span>` : ""}
        </button>
        ${loggedIn ? `
        <div class="gegix-selector-dropdown" id="gegix-dropdown-${type}" role="listbox">
          <div class="gegix-selector-loading">
            <div class="gegix-selector-spinner"></div>
            <span>Loading your profiles...</span>
          </div>
        </div>` : ""}
          <div class="gegix-error" id="gegix-error-${type}" style="display:none"></div>
        </div>
    `;
  }

  function buildDropdownItems(type, profiles) {
    if (!profiles || profiles.length === 0) {
      const createPath = type === "body" ? "new-body-profile" : "new-embroidery-profile";
      return `
        <div class="gegix-dropdown-empty">
          No ${type === "body" ? "body" : "embroidery"} profiles yet.
          <a href="/pages/${createPath}?email=${encodeURIComponent(customerEmail)}" target="_blank">
            Create one now
          </a>
        </div>`;
    }

    let items = "";
    profiles.forEach((p, i) => {
      const isBody = type === "body";
      const subtitle = isBody
        ? `${p.category || ""}${p.sub_category ? " · " + p.sub_category : ""}`
        : p.embroidery_text || "Embroidery";
      items += `
        <button type="button" class="gegix-dropdown-item" role="option" data-value="${p.id}" data-type="${type}">
          <span>
            <div>${p.profile_name || p.who || "Unnamed"}</div>
            <div class="gegix-item-subtitle">${subtitle}</div>
          </span>
          <span class="gegix-item-check" style="display:none">${ICONS.check}</span>
        </button>`;
    });

    items += `<div class="gegix-dropdown-divider"></div>`;
    items += `
      <button type="button" class="gegix-dropdown-item gegix-dropdown-create" data-action="create" data-type="${type}">
        + New ${type === "body" ? "Body Profile" : "Embroidery Archive"}
      </button>`;

    return items;
  }

  function getCompatibleBodyProfiles(profiles) {
    if (!profiles || !profiles.length || !productProfileRule.category) return profiles || [];

    const matching = profiles.filter((profile) => {
      const category = String(profile.category || "").trim();
      const subCategory = String(profile.sub_category || "").trim();
      return category === productProfileRule.category &&
        (!productProfileRule.subCategory || subCategory === productProfileRule.subCategory);
    });

    // Preserve legacy/unclassified profiles instead of making them disappear.
    return matching.length ? matching.concat(profiles.filter((profile) => !profile.category && !profile.sub_category)) : profiles;
  }

  // ─── API ─────────────────────────────────────────────

  async function fetchProfiles(email) {
    try {
      const res = await fetch(
        `${SAAS_BASE}/api/public/product-profiles?email=${encodeURIComponent(email)}`
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      bodyProfiles = data.body_profiles || [];
      embroideryProfiles = data.embroidery_profiles || [];
      profilesLoaded = true;
    } catch (err) {
      console.error("[GEGIX Customizer] Failed to load profiles:", err);
      bodyProfiles = [];
      embroideryProfiles = [];
      profilesLoaded = true;
    }
  }

  // ─── Dropdown UI ─────────────────────────────────────

  function openDropdown(type) {
    const dropdown = type === "body" ? bodyDropdown : embDropdown;
    const trigger = type === "body" ? bodyTrigger : document.getElementById("gegix-trigger-embroidery");
    closeAllDropdowns(type);
    dropdown.classList.add("gegix-open");
    trigger.setAttribute("aria-expanded", "true");
  }

  function closeAllDropdowns(except) {
    ["body", "embroidery"].forEach((t) => {
      if (t === except) return;
      const dd = t === "body" ? bodyDropdown : embDropdown;
      const tr = t === "body" ? bodyTrigger : document.getElementById("gegix-trigger-embroidery");
      if (dd) dd.classList.remove("gegix-open");
      if (tr) tr.setAttribute("aria-expanded", "false");
    });
  }

  function selectProfile(type, id) {
    const profiles = type === "body" ? bodyProfiles : embroideryProfiles;
    const profile = profiles.find((p) => p.id === id);
    if (!profile) return;

    if (type === "body") {
      selectedBodyProfile = profile;
    } else {
      selectedEmbroideryProfile = profile;
    }

    // Update trigger label
    const trigger = type === "body" ? bodyTrigger : document.getElementById("gegix-trigger-embroidery");
    const label = trigger.querySelector(".gegix-trigger-label");
    const subtitle =
      type === "body"
        ? `${profile.category || ""}${profile.sub_category ? " · " + profile.sub_category : ""}`
        : profile.embroidery_text || "Embroidery";
    label.innerHTML = `
      <div class="gegix-selected-value">${profile.profile_name || profile.who || "Unnamed"}</div>
      <div class="gegix-selected-subtitle">${subtitle}</div>`;
    label.classList.remove("gegix-trigger-placeholder");

    // Update check marks
    const dropdown = type === "body" ? bodyDropdown : embDropdown;
    dropdown.querySelectorAll(".gegix-dropdown-item[data-value]").forEach((btn) => {
      const check = btn.querySelector(".gegix-item-check");
      if (btn.dataset.value === id) {
        btn.classList.add("gegix-selected");
        check.style.display = "";
      } else {
        btn.classList.remove("gegix-selected");
        check.style.display = "none";
      }
    });

    // Update form hidden inputs
    updateFormInputs();

    closeAllDropdowns();
  }

  function clearEmbroiderySelection() {
    selectedEmbroideryProfile = null;
    const trigger = document.getElementById("gegix-trigger-embroidery");
    if (trigger) {
      const label = trigger.querySelector(".gegix-trigger-label");
      label.innerHTML = "Select Embroidery...";
      label.classList.add("gegix-trigger-placeholder");
    }
  }

  function updateFormInputs() {
    // ── Internal / hidden fields (starts with _) ─────
    upsertHiddenInput("_body_profile_id", selectedBodyProfile ? selectedBodyProfile.id : "");
    upsertHiddenInput(
      "_body_profile_name",
      selectedBodyProfile ? selectedBodyProfile.profile_name || selectedBodyProfile.who || "" : ""
    );
    upsertHiddenInput("_embroidery_profile_id", embroideryWanted && selectedEmbroideryProfile ? selectedEmbroideryProfile.id : "");
    upsertHiddenInput("_embroidery_text", embroideryWanted && selectedEmbroideryProfile ? (selectedEmbroideryProfile.embroidery_text || "") : "");

    // ── Display fields (visible in cart — no _ prefix) ─
    // Body Profile display
    if (selectedBodyProfile) {
      const name = selectedBodyProfile.profile_name || selectedBodyProfile.who || "Custom";
      const cat = selectedBodyProfile.category || "";
      upsertHiddenInput("Body Profile", cat ? `${name} — ${cat}` : name);
    } else {
      upsertHiddenInput("Body Profile", "");
    }

    // Embroidery display
    if (embroideryWanted && selectedEmbroideryProfile) {
      const epName = selectedEmbroideryProfile.profile_name || selectedEmbroideryProfile.who || "Custom";
      const epText = selectedEmbroideryProfile.embroidery_text || "";
      upsertHiddenInput("Embroidery", epText ? `${epName} — "${epText}"` : epName);
    } else if (embroideryWanted) {
      upsertHiddenInput("Embroidery", "Pending selection");
    } else {
      upsertHiddenInput("Embroidery", "");
    }
  }

  function upsertHiddenInput(name, value) {
    const form = document.querySelector("product-form form");
    if (!form) return;
    let input = form.querySelector(`input[name="properties[${name}]"]`);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value;
  }

  /** Re-fetch profiles after creating a new one in another tab */
  async function refreshProfiles() {
    if (!customerEmail) return;
    await fetchProfiles(customerEmail);
    renderDropdowns();
    // Re-apply selected state
    if (selectedBodyProfile) {
      const stillExists = bodyProfiles.find(p => p.id === selectedBodyProfile.id);
      if (!stillExists) selectedBodyProfile = null;
    }
  }

  // ─── Init ────────────────────────────────────────────

  function init() {
    // Find product form container
    const productForm = document.querySelector(".product-form, product-form, [data-product-form]");
    const buyButtons = document.querySelector(".product-form__buttons, .shopify-payment-button");
    const target = buyButtons ? buyButtons.parentNode : productForm;

    if (!target) {
      // Retry on DOM ready
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
      }
      return;
    }

    // Build and inject container
    container = buildContainer();
    if (buyButtons) {
      target.insertBefore(container, buyButtons);
    } else if (productForm) {
      productForm.appendChild(container);
    }

    // Cache DOM refs
    bodyTrigger = document.getElementById("gegix-trigger-body");
    bodyDropdown = document.getElementById("gegix-dropdown-body");
    embToggleYes = document.getElementById("gegix-toggle-emb-yes");
    embToggleNo = document.getElementById("gegix-toggle-emb-no");
    embBody = document.getElementById("gegix-embroidery-body");
    embDropdown = document.getElementById("gegix-dropdown-embroidery");

    // If not logged in
    if (!customerEmail) {
      if (bodyTrigger) {
        bodyTrigger.addEventListener("click", () => {
          window.location.href = "/account/login";
        });
      }
      if (supportsEmbroidery) {
        [embToggleYes, embToggleNo].forEach((btn) => {
          if (btn) {
            btn.addEventListener("click", () => {
              window.location.href = "/account/login";
            });
          }
        });
      }
      return;
    }

    // Fetch profiles and populate
    fetchProfiles(customerEmail).then(() => {
      renderDropdowns();
      setupEventListeners();
    });
  }

  function renderDropdowns() {
    if (bodyDropdown) {
      bodyDropdown.innerHTML = buildDropdownItems("body", getCompatibleBodyProfiles(bodyProfiles));
    }
    if (embDropdown) {
      embDropdown.innerHTML = buildDropdownItems("embroidery", embroideryProfiles);
    }
  }

  function setupEventListeners() {
    // Body trigger
    bodyTrigger.addEventListener("click", (e) => {
      e.stopPropagation();
      if (bodyDropdown.classList.contains("gegix-open")) {
        closeAllDropdowns();
      } else {
        openDropdown("body");
      }
    });

    function disableEmbroidery() {
      embroideryWanted = false;
      selectedEmbroideryProfile = null;
      updateFormInputs();
    }

    if (supportsEmbroidery) {
      // Embroidery toggle buttons
      function setEmbroideryYes() {
        embroideryWanted = true;
        embToggleYes.classList.add("gegix-toggle-active");
        embToggleNo.classList.remove("gegix-toggle-active");
        embBody.style.display = "block";
        embBody.style.animation = "gegix-fadeIn 0.2s ease";
        // Reset selected if any
        clearEmbroiderySelection();
        // Load profiles into dropdown
        renderDropdowns();
      }

      function setEmbroideryNo() {
        embroideryWanted = false;
        embToggleNo.classList.add("gegix-toggle-active");
        embToggleYes.classList.remove("gegix-toggle-active");
        embBody.style.display = "none";
        selectedEmbroideryProfile = null;
        updateFormInputs();
      }

      embToggleYes.addEventListener("click", (e) => {
        e.stopPropagation();
        setEmbroideryYes();
      });
      embToggleNo.addEventListener("click", (e) => {
        e.stopPropagation();
        setEmbroideryNo();
      });

      // Embroidery trigger (inside collapsed body)
      const embTrigger = document.getElementById("gegix-trigger-embroidery");
      if (embTrigger) {
        embTrigger.addEventListener("click", (e) => {
          e.stopPropagation();
          if (embDropdown.classList.contains("gegix-open")) {
            closeAllDropdowns();
          } else {
            openDropdown("embroidery");
          }
        });
      }

      // Default: No selected
      setEmbroideryNo();
    } else {
      disableEmbroidery();
    }

    // Item clicks (delegated)
    document.addEventListener("click", (e) => {
      const item = e.target.closest(".gegix-dropdown-item");
      if (!item) return;

      const dropdown = item.closest(".gegix-selector-dropdown");
      if (!dropdown) return;

      const type = item.dataset.type;

      // "Create new" action
      if (item.dataset.action === "create") {
        const url =
          type === "body"
            ? `/pages/new-body-profile?email=${encodeURIComponent(customerEmail)}`
            : `/pages/new-embroidery-profile?email=${encodeURIComponent(customerEmail)}`;
        window.open(url, "_blank");
        setTimeout(refreshProfiles, 500);
      }

      // Select item
      const value = item.dataset.value;
      if (value) {
        selectProfile(type, value);
      }
    });

    // Click outside to close
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".gegix-profile-section")) {
        closeAllDropdowns();
      }
    });

    // Watch product form submit — validate inputs (capture phase, before product-form)
    const form = document.querySelector("product-form form");
    if (form) {
      form.addEventListener("submit", (e) => {
        // Ensure inputs are up to date
        updateFormInputs();

        // Validate
        const errors = [];
        const bodyErr = document.getElementById("gegix-error-body");
        const embErr = document.getElementById("gegix-error-embroidery");

        // Clear previous errors
        [bodyErr, embErr].forEach((el) => {
          if (el) { el.style.display = "none"; el.textContent = ""; }
        });
        document.querySelectorAll(".gegix-selector-trigger.gegix-input-error").forEach((el) => {
          el.classList.remove("gegix-input-error");
        });

        if (!selectedBodyProfile) {
          errors.push("body");
          if (bodyErr) {
            bodyErr.textContent = "Please select a Body Profile before adding to cart.";
            bodyErr.style.display = "block";
          }
          const trigger = document.getElementById("gegix-trigger-body");
          if (trigger) trigger.classList.add("gegix-input-error");
        }

        if (embroideryWanted && !selectedEmbroideryProfile) {
          errors.push("embroidery");
          if (embErr) {
            embErr.textContent = "Please select an Embroidery profile or choose \"No, thanks\".";
            embErr.style.display = "block";
          }
          const trigger = document.getElementById("gegix-trigger-embroidery");
          if (trigger) trigger.classList.add("gegix-input-error");
        }

        if (errors.length > 0) {
          e.preventDefault();
          e.stopPropagation();
          // Scroll to customizer
          const customizer = document.getElementById("gegix-customizer");
          if (customizer) customizer.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, { capture: true });
    }
  }

  // ─── Mobile Sticky Buy Bar ──────────────────────────

  function buildStickyBar() {
    if (window.innerWidth > 749) return;

    const form = document.querySelector("product-form form");
    if (!form) return;

    const mainSubmit = form.querySelector(".product-form__submit");
    const mainQty = form.querySelector("quantity-input input[name='quantity']");
    const priceEl = document.querySelector(".product__price .price .price__regular .price-item--regular, .price__regular .price-item--regular");
    const compareEl = document.querySelector(".product__price .price .price__sale .price-item--sale, .price__sale .price-item--sale");

    // Don't duplicate
    if (document.getElementById("gegix-sticky-bar")) return;

    const bar = document.createElement("div");
    bar.id = "gegix-sticky-bar";
    bar.className = "gegix-sticky-bar";

    // Price
    const pricing = document.createElement("div");
    pricing.className = "gegix-sticky-price";
    pricing.id = "gegix-sticky-price";
    if (priceEl) pricing.innerHTML = priceEl.textContent.trim();
    if (compareEl) {
      const span = document.createElement("span");
      span.className = "gegix-sticky-compare";
      span.textContent = compareEl.textContent.trim();
      pricing.appendChild(span);
    }
    bar.appendChild(pricing);

    // Quantity
    const qtyWrap = document.createElement("div");
    qtyWrap.className = "gegix-sticky-quantity";
    qtyWrap.innerHTML =
      '<button class="gegix-sticky-qty-btn" id="gegix-sticky-qty-minus">−</button>' +
      '<input class="gegix-sticky-qty-value" id="gegix-sticky-qty-input" type="text" inputmode="numeric" value="' + (mainQty ? mainQty.value : "1") + '">' +
      '<button class="gegix-sticky-qty-btn" id="gegix-sticky-qty-plus">+</button>';
    bar.appendChild(qtyWrap);

    // ATC button
    const atc = document.createElement("button");
    atc.className = "gegix-sticky-atc";
    atc.id = "gegix-sticky-atc";
    atc.textContent = mainSubmit && !mainSubmit.disabled ? "Add to Cart" : "Sold Out";
    if (mainSubmit && mainSubmit.disabled) atc.classList.add("gegix-sticky-soldout");
    bar.appendChild(atc);

    document.body.appendChild(bar);

    // ─── Sync quantity ───
    const stickyQtyInput = document.getElementById("gegix-sticky-qty-input");
    const minusBtn = document.getElementById("gegix-sticky-qty-minus");
    const plusBtn = document.getElementById("gegix-sticky-qty-plus");

    function updateMainQty(val) {
      const qty = Math.max(1, parseInt(val) || 1);
      if (mainQty) { mainQty.value = qty; mainQty.dispatchEvent(new Event("change", { bubbles: true })); }
      if (stickyQtyInput) stickyQtyInput.value = qty;
    }

    if (minusBtn) minusBtn.addEventListener("click", function () {
      updateMainQty((parseInt(stickyQtyInput.value) || 1) - 1);
    });
    if (plusBtn) plusBtn.addEventListener("click", function () {
      updateMainQty((parseInt(stickyQtyInput.value) || 1) + 1);
    });
    if (stickyQtyInput) {
      stickyQtyInput.addEventListener("change", function () {
        updateMainQty(this.value);
      });
    }

    // Sync main qty → sticky
    if (mainQty) {
      mainQty.addEventListener("change", function () {
        if (stickyQtyInput) stickyQtyInput.value = this.value;
      });
    }

    // ─── ATC click → trigger main form ───
    atc.addEventListener("click", function () {
      if (this.classList.contains("gegix-sticky-soldout")) return;
      if (mainSubmit) mainSubmit.click();
    });

    // ─── Update price when variant changes ───
    const origUpdatePrice = window.updateStickyPrice;
    window.updateStickyPrice = function () {
      const el = document.querySelector(".price__regular .price-item--regular");
      const saleEl = document.querySelector(".price__sale .price-item--sale");
      const stickyPrice = document.getElementById("gegix-sticky-price");
      if (!stickyPrice) return;
      if (el) stickyPrice.innerHTML = el.textContent.trim();
      if (saleEl) {
        const span = stickyPrice.querySelector(".gegix-sticky-compare") || document.createElement("span");
        span.className = "gegix-sticky-compare";
        span.textContent = saleEl.textContent.trim();
        if (!stickyPrice.querySelector(".gegix-sticky-compare")) stickyPrice.appendChild(span);
      }
      // Update ATC state
      const btn = document.getElementById("gegix-sticky-atc");
      if (!btn) return;
      const submit = document.querySelector("product-form form .product-form__submit");
      if (submit && submit.disabled) {
        btn.textContent = submit.textContent.trim() || "Sold Out";
        btn.classList.add("gegix-sticky-soldout");
      } else {
        btn.textContent = "Add to Cart";
        btn.classList.remove("gegix-sticky-soldout");
      }
    };

    // Watch for variant change events from Shopify
    document.addEventListener("variant:changed", window.updateStickyPrice);
    // Also poll on intersection for safety
    const priceObserver = new MutationObserver(function () {
      if (window.updateStickyPrice) window.updateStickyPrice();
    });
    const priceTarget = document.querySelector(".price");
    if (priceTarget) priceObserver.observe(priceTarget, { childList: true, subtree: true, characterData: true });

    // ─── Hide bar on scroll to top, show on scroll down ───
    let lastScroll = 0;
    const scrollThreshold = 100;
    window.addEventListener("scroll", function () {
      const currentScroll = window.pageYOffset;
      if (currentScroll < scrollThreshold) {
        bar.classList.add("gegix-sticky-hidden");
      } else {
        bar.classList.remove("gegix-sticky-hidden");
      }
      lastScroll = currentScroll;
    }, { passive: true });

    // Initial state: hidden at top
    bar.classList.add("gegix-sticky-hidden");
  }

  // Call after profiles render
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      setTimeout(buildStickyBar, 500);
    });
  } else {
    setTimeout(buildStickyBar, 500);
  }

  // ─── Boot ─────────────────────────────────────────────

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
